// @flow
import cn from 'classnames';
import React from 'react';
import styles from './styles.local.less';

type TProps = {hasToasts: boolean};

/**
 * Контейнер для уведомлений
 * @param hasToasts наличие уведомлений в контейнере
 * @param props Свойства
 * @returns React-компонент
 */
export const NotificationContainer = ({hasToasts, ...props}: TProps) => {
    return <div {...props} className={cn(styles.container, {[styles.disable]: !hasToasts})} />;
};
